/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
  name: ZodTypes.Base64,
});

export const GetClusterLogicalBackupFile = {
  id: 'cluster-logical-backup-file.get',
  tag: 'Cluster',
  summary: 'Get cluster logical backup file',
  description: 'Retrieve a cluster logical backup file',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/backup/logical/file/${params.name}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.any(),
        },
      },
    },
  },
} as const satisfies Endpoint;
